const adminSubscribeRouter = [
  {
    path: '/admin/subscribe',
    name: 'AdminSubscribe',
    component: () => import('@/views/admin/subscribe/index')
  }
]

export default adminSubscribeRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/subscribe.js